import { Injectable } from '@angular/core';
import { LMSpecService, LMUrlUtilService } from '@app/services';
import { Subject } from 'rxjs';

@Injectable()
export class LMCaptchaControlService {
  public captchaValue: string;
  private _updateCaptcha: boolean;
  public captchaChanged: Subject<boolean> = new Subject<boolean>();

  constructor(
    private lmUrlUtilService: LMUrlUtilService,
    private lmSpecService: LMSpecService
  ) {
    this.captchaChanged.subscribe((bool) => this._updateCaptcha = bool);
  }

  public updateCaptcha() {
    this.captchaChanged.next(true);
  }

  public getCaptchaValue(): string {
    return this.captchaValue;
  }

  public setCaptchaValue(value: string): void {
    this.captchaValue = value;
  }

  public getCaptchaBase64Url(): Promise<string> {
    return this.loadCaptcha();
  }

  private loadCaptcha(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.lmSpecService.getCaptchaSpec(this.lmUrlUtilService.getCaptchaSpecUrl())
        .subscribe((response) => {
          resolve(response.base64ImageUrl);
        }, error => reject(error));
    });
  }
}
